import React from 'react';
import { connect } from 'react-redux';
import { Table } from 'reactstrap';
import i18n from "../../../i18next";

import WebSVG from '../../common/svgs/WebSVG';
import MobileIconSVG from '../../common/svgs/MobileIconSVG';
import AppAndroidSVG from '../../common/svgs/AppAndroidSVG';
import AppAppleSVG from '../../common/svgs/AppAppleSVG';
import CustomerInsightSearchOptions from './CustomerInsightSearchOptions';
import { loadCustomerInsightSourceSearchSummary } from '../../../actions/restaurants/customerInsight/CustomerInsightAction';
import { loadRestaurantInsightSourceSearchSummary } from '../../../actions/restaurants/restaurantInsight/RestaurantInsightAction';
import { getPriceWithCurrencySymbol } from '../../../utils/CommonUtils';


class SourceTypeSearch extends React.Component {

    state = {
        fromDate: '',
        toDate: ''
    }

    componentDidMount() {
        const { restaurantId, customerId } = this.props;
         if(this.props.insightType ==='restaurant') {
            this.props.loadRestaurantInsightSourceSearchSummary(restaurantId, this.state.fromDate, this.state.toDate);
         } else {
            this.props.loadCustomerInsightSourceSearchSummary(restaurantId, customerId, this.state.fromDate, this.state.toDate);
         }
    }

    takeSearchOptionState = searchOptionState => {
        if(this.props.insightType ==='restaurant') {
            this.setState({
                fromDate: searchOptionState.fromDate,
                toDate: searchOptionState.toDate
            })
    
            const { restaurantId, customerId } = this.props;
            this.props.loadRestaurantInsightSourceSearchSummary(restaurantId, searchOptionState.fromDate, searchOptionState.toDate);
        } else {
            this.setState({
                fromDate: searchOptionState.fromDate,
                toDate: searchOptionState.toDate
            })
    
            const { restaurantId, customerId } = this.props;
            this.props.loadCustomerInsightSourceSearchSummary(restaurantId, customerId, searchOptionState.fromDate, searchOptionState.toDate);
        }  
    }

    renderSourceTypeTable = () => {
        return (
            <Table bordered hover style={{ marginTop: '5px' }}>
                <thead>
                    {this.renderTableHeaders()}
                </thead>
                <tbody>
                    {this.renderTableContent()}
                </tbody>
            </Table>
        );
    }

    renderTableHeaders = () => {

        const { tableHeaders, textCenter, textRight } = styles;

        return (
            <tr>
                <th style={{ ...tableHeaders }}>{i18n.t('screens:customerInsightScreen.sourceType')}</th>
                <th style={{ ...tableHeaders, ...textCenter }}>{i18n.t('screens:customerInsightScreen.count')}</th>
                <th style={{ ...tableHeaders, ...textRight }}>{i18n.t('screens:customerInsightScreen.totalSpent')}</th>
                {this.props.insightType === 'restaurant' && <th style={{ ...tableHeaders, ...textRight }}>{i18n.t('screens:restaurantInsightScreen.giftCardTotal')}</th>}
            </tr>
        );
    }

    renderTableContent = () => {
        if(this.props.insightType ==='restaurant' && this.props.restaurantInsightSourceTypes) {
            return this.props.restaurantInsightSourceTypes.map(item => {
                return this.renderSingleItem(item);
            })
        } else {
            return this.props.customerInsightSourceTypes.map(item => {
                return this.renderSingleItem(item);
            })
        } 
    }

    renderSingleItem = item => {

        const { tableDetail, verticleAlignCenter, textCenter, textRight } = styles;
        const currency = this.props.restaurant.currency;
        
        return (
            <tr>
                <td style={{ ...tableDetail, ...verticleAlignCenter }}>{this.renderSourceSVGIcon(item.typeOrName)}&nbsp;&nbsp;{this.renderSourceTypeName(item.typeOrName)}</td>
                <td style={{ ...tableDetail, ...textCenter }}>{item.count}</td>
                <td style={{ ...tableDetail, ...textRight }}>{getPriceWithCurrencySymbol(item.totalSpent, currency)}</td>
                {this.props.insightType === 'restaurant' && <td style={{ ...tableDetail, ...textRight }}>{getPriceWithCurrencySymbol(item.giftCardTotal, currency)}</td>}
            </tr>
        );
    }

    renderSourceSVGIcon = type => {
        switch (type) {
            case "WEB": return <WebSVG width={13} height={13} fill={'#0288D1'} />
            case "WEB_ANDROID": return <MobileIconSVG width={16} height={16} fill={'#0288D1'} />
            case "WEB_IOS": return <MobileIconSVG width={16} height={16} fill={'#0288D1'} />
            case "APP_ANDROID": return <AppAndroidSVG width={16} height={16} fill={'#0288D1'} />
            case "APP_IOS": return <AppAppleSVG width={16} height={16} fill={'#0288D1'} />
            default: return null
        }
    }

    renderSourceTypeName = type => {
        switch (type) {
            case "WEB": return "Web";
            case "WEB_ANDROID": return "Web Android";
            case "WEB_IOS": return "Web IOS";
            case "APP_ANDROID": return "App Android";
            case "APP_IOS": return "App IOS";
            default: return null
        }
    }

    render() {
        return (
            <React.Fragment>
                <CustomerInsightSearchOptions type="SourceTypes" takeSearchOptionState={this.takeSearchOptionState} />
                {this.renderSourceTypeTable()}
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        customerInsightSourceTypes: state.customerInsightSourceTypes,
        restaurantInsightSourceTypes: state.restaurantInsight.sourceTypeSummary,
        restaurant: state.restaurant
    }
};

export default connect(mapStateToProps, { 
    loadCustomerInsightSourceSearchSummary,
    loadRestaurantInsightSourceSearchSummary })(SourceTypeSearch);

const styles = {
    tableHeaders: {
        padding: '10px',
        fontSize: '16px',
        fontWeight: 'bold',
    },
    tableDetail: {
        padding: '10px',
        fontSize: '14px',   //previously it was 14px not bolded
        fontWeight: 'bold',
    },
    firstRow: {
        //whiteSpace: 'nowrap'
        paddingRight: '0'
    },
    textCenter: {
        textAlign: 'center',
        padding: '10px 5px'
    },
    textRight: {
        textAlign: 'right',
        paddingLeft: '0'
    },
    verticleAlignCenter: {
        display: 'flex',
        alignItems: 'center'
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/customerInsightScreen/SourceTypeSearch.js